export class BoxSelectionEvent {
	public constructor(
		public boxId: string,
		public selected: boolean
	) {}
}
